<template>
  <div class="topbar container">
    <nav-toggle></nav-toggle>
    <breadcrumb :path="breadcrumb"></breadcrumb>
    <topbar-settings
      ref="topbarSettings"
      v-if="hasSettings">
      <slot name="settings" slot="settings"></slot>
    </topbar-settings>
  </div>
</template>

<script>
import NavToggle from './topbar/NavToggle';
import TopbarSettings from './topbar/TopbarSettings';
import Breadcrumb from '@/components/shared/topbar/Breadcrumb';

export default {
  components: {
    NavToggle,
    TopbarSettings,
    Breadcrumb
  },
  props: {
    breadcrumb: {
      type: Array,
      default: () => []
    },
    hasSettings: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/stylesheets/variables";
.topbar {
  background-color: $custom-topbar-color;
  color: $bodycolor-inverse;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/TopBar.vue